"use strict";
//
// Copyright © 2021 Anticrm Platform Contributors.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingOrder = void 0;
exports.shouldShowArchived = shouldShowArchived;
/**
 * @public
 */
var SortingOrder;
(function (SortingOrder) {
    SortingOrder[SortingOrder["Ascending"] = 1] = "Ascending";
    SortingOrder[SortingOrder["Descending"] = -1] = "Descending";
})(SortingOrder || (exports.SortingOrder = SortingOrder = {}));
function shouldShowArchived(query, options) {
    if (options?.showArchived !== undefined) {
        return options.showArchived;
    }
    if (query._id !== undefined && typeof query._id === 'string') {
        return true;
    }
    if (query.space !== undefined && typeof query.space === 'string') {
        return true;
    }
    return false;
}
//# sourceMappingURL=storage.js.map